import React, { useEffect, useRef } from 'react';

import * as styles from './VideoBanner.module.scss';

const VideoBanner = ({ colorTheme, offset, cta }) => {
  const bannerRef = useRef(null);
  const [displayVideoBanner, setDisplayVideoBanner] = React.useState(false);

  useEffect(() => {
    const target = bannerRef.current;
    if (!target) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setDisplayVideoBanner(true);
        } else if (entry.boundingClientRect.top > 0) {
          // Only set to false if scrolling back above the element

          setDisplayVideoBanner(false);
        }
      },
      {
        root: null, // Use the viewport as the root
        rootMargin: `${offset?.toString() || '0'}px`,
        threshold: 0.75,
      }
    );

    if (target) {
      observer.observe(target);
    }

    return () => {
      if (target) {
        observer.unobserve(target);
      }
    };
  }, [offset]);

  if (process.env.GATSBY_DISPLAY_VIDEO_BANNER === 'false') return null;

  return (
    <React.Fragment>
      <div ref={bannerRef} />
      <VideoBannerDisplay cta={cta} colorTheme={colorTheme} display={displayVideoBanner} />
    </React.Fragment>
  );
};

const VideoBannerDisplay = ({ colorTheme = 'Evergreen', display, cta }) => {
  const themes = {
    Evergreen: styles.evergreen,
    'Pink 75% Tint': styles.pink75,
    'Pink 50% Tint': styles.pink50,
    'Pink 25% Tint': styles.pink25,
  };

  let callToAction = (
    <>
      comprehensive VIDEO product tours now AVAILABLE!{' '}
      <a href={'/product-tour/'} target={'_blank'} rel="noopener noreferrer" className={styles.videoButton}>
        START NOW
      </a>
    </>
  );

  if (cta) {
    callToAction = (
      <>
        {cta.description?.description}{' '}
        <a href={cta.url} target={'_blank'} rel="noopener noreferrer" className={styles.videoButton}>
          {cta.ctaLabel}
        </a>
      </>
    );
  }

  return (
    <div
      className={[styles.videoMessageWrap, display ? styles.slideDown : styles.slideUp, themes[colorTheme]].join(' ')}
    >
      <div className={styles.videoMessage}>
        <div></div>
        <div style={{ textTransform: 'uppercase' }}>
          {display}
          {callToAction}
        </div>
        <div></div>
      </div>
    </div>
  );
};

export default VideoBanner;
